module.exports = __webpack_public_path__ + "img/back--mini.7fcd5c8d.svg";